import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InboxMessageImpression = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M17.3223 7.18994V2.68994C17.3223 2.39157 17.2037 2.10542 16.9928 1.89445C16.7818 1.68347 16.4956 1.56494 16.1973 1.56494H2.69727C2.3989 1.56494 2.11275 1.68347 1.90177 1.89445C1.69079 2.10542 1.57227 2.39157 1.57227 2.68994V15.0649C1.57227 15.3633 1.69079 15.6495 1.90177 15.8604C2.11275 16.0714 2.3989 16.1899 2.69727 16.1899H7.19727"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.57227 4.93994H17.3223"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9736 12.7959C20.0609 12.9091 20.1082 13.0479 20.1082 13.1908C20.1082 13.3336 20.0609 13.4725 19.9736 13.5856C19.304 14.4681 17.4621 16.4999 14.8076 16.4999C12.1531 16.4999 10.3113 14.4681 9.64167 13.5848C9.55471 13.4715 9.50757 13.3327 9.50757 13.1899C9.50757 13.0471 9.55471 12.9083 9.64167 12.795C10.3122 11.9169 12.1531 9.87988 14.8076 9.87988C17.4621 9.87988 19.304 11.9169 19.9736 12.7959Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8079 13.5209C14.9908 13.5209 15.1391 13.3726 15.1391 13.1897C15.1391 13.0067 14.9908 12.8584 14.8079 12.8584"
      stroke="#3D3A3B"
      strokeWidth="1.5"
    />
  </SvgIcon>
);
